<template>
    <aicc-page :pageId="contextPageId">
        <ur-area>
            <ur-form-box column="7" labelAlign="right">
                <ur-form-row>
                    <ur-form-item :label="searchInfo.type.label" colSpan="2">
                        <ur-dropdown style="width:240px; margin-left:16px" v-model="searchInfo.type.value" :items="searchInfo.type.items" :itemWidth="240"/>    
                    </ur-form-item>
                    <ur-form-item :label="searchInfo.date.label" colSpan="2">
                        <aicc-range-picker style="margin-left:16px; min-width:271px" v-model="date" :init="searchInfo.date.init" modelType="YYYYMMDD" cancelLabel="취소" confirmLabel="확인" strict-range autoConfirm :limitRange="31"/>
                    </ur-form-item>
                    <ur-form-item :label="searchInfo.status.label" colSpan="2">
                        <aicc-multi-dropdown style="width:240px; margin-left:16px" ref="statusDropdown" :searchable="false" select-all selectedAllText="전체" applyBtn v-model="searchInfo.status.value" :items="searchInfo.status.items" :itemsSize="240"/>
                    </ur-form-item>
                    <ur-form-item noLabel noFlex>
                        <ur-button class="search-button" solid primary text="조회" @click="onClickSearchButton"/>
                    </ur-form-item>
                </ur-form-row>
            </ur-form-box>
            <ur-table :headers="headers" :items="items" :pagination="pagination" :sortable="true" :resizeColumn="true" @click-row="onClickRow" @change="changeRowPerPage" :noDataText="noDataText" :totalText="totalText" :perPageText="perPageText">
                <template #extra-action>
                    <ur-button class="sr_btn" @click="onClickSRButton" large primary><i class="sr_icon"/> 변경 요청하기</ur-button>
                </template>
                <template slot="colgroup">
                    <col style="width:172px">
                    <col style="width:816px">
                    <col style="width:132px">
                    <col style="width:132px">
                    <col style="width:132px">
                </template>
                <template slot="items" slot-scope="props">
                    <td><ur-badge shape="dot" :color="getStatusColor(props.item.srStatusCode)" :text="getStatusText(props.item.srStatusCode)"/></td>
                    <td>{{getTypeText(props.item.srType)}}</td>
                    <td>{{props.item.requestUserName}}</td>
                    <td>{{getFormattedDate(props.item.firstRegistrationDTM)}}</td>
                    <td>{{getFormattedDate(props.item.finalModificationDTM)}}</td>
                </template>
            </ur-table>
            <ur-pagination :pagination="pagination" @move="changeCurrentPage"/>
            <div class="more_info">
                <div>
                    <div class="txt_info"><i/>수신 고객의 스마트폰에 원하는 이미지를 표시할 수 있는&nbsp<strong>'스마트 레터링'</strong>&nbsp서비스도 이용 가능합니다.&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp<span class="underline" @click="onClickServiceCenter">자세히보기</span></div>
                    <div class="txt_info" style="margin-top:8px"><i/>고객에게 070번호가 아닌 기존 사용중인 특정 번호로 발신되길 원하시면&nbsp<strong>'발신번호 변경'</strong>을 진행해주세요.&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp<span class="underline" @click="onClickServiceCenter">자세히보기</span></div>
                </div>
            </div>
        </ur-area>
        <!--
        <ur-area>
            <ur-form-box column="4" labelAlign="right">
                <div class="search-box">
                    <div class="search-box__label__first">
                        {{searchInfo.type.label}}
                    </div>
                    <ur-dropdown style="width:240px; margin-left:16px" v-model="searchInfo.type.value" :items="searchInfo.type.items" :itemWidth="240"/>
                    <div class="search-box__label">
                        {{searchInfo.date.label}}
                    </div>
                    <aicc-range-picker style="margin-left:16px" v-model="searchInfo.date.value" :init="searchInfo.date.init" modelType="YYYYMMDD" cancelLabel="취소" confirmLabel="확인" strict-range autoConfirm :limitRange="31"/>
                    <div class="search-box__label">
                        {{searchInfo.status.label}}
                    </div>
                    <aicc-multi-dropdown style="width:240px; margin-left:16px" ref="statusDropdown" :searchable="false" select-all selectedAllText="전체" applyBtn v-model="searchInfo.status.value" :items="searchInfo.status.items" :itemsSize="240"/>
                    <div style="flex: 1;">
                        <ur-button class="search-button" solid primary text="조회" @click="onClickSearchButton"/>
                    </div>
                </div>
            </ur-form-box>
            <ur-table :headers="headers" :items="items" :pagination="pagination" :sortable="true" :resizeColumn="true" @click-row="onClickRow" @change="changeRowPerPage" :noDataText="noDataText" :totalText="totalText" :perPageText="perPageText">
                <template #extra-action>
                    <ur-button class="sr_btn" @click="onClickSRButton" large primary><i class="sr_icon"/> 변경 요청하기</ur-button>
                </template>
                <template slot="colgroup">
                    <col style="width:172px">
                    <col style="width:816px">
                    <col style="width:132px">
                    <col style="width:132px">
                    <col style="width:132px">
                </template>
                <template slot="items" slot-scope="props">
                    <td><ur-badge shape="dot" :color="getStatusColor(props.item.srStatusCode)" :text="getStatusText(props.item.srStatusCode)"/></td>
                    <td>{{getTypeText(props.item.srType)}}</td>
                    <td>{{props.item.requestUserName}}</td>
                    <td>{{getFormattedDate(props.item.firstRegistrationDTM)}}</td>
                    <td>{{getFormattedDate(props.item.finalModificationDTM)}}</td>
                </template>
            </ur-table>
            <ur-pagination :pagination="pagination" @move="changeCurrentPage"/>
            <div class="more_info">
                <div>
                    <div class="txt_info">수신 고객의 스마트폰에 원하는 이미지를 표시할 수 있는 <strong>'스마트 레터링'</strong> 서비스도 이용 가능합니다.  <span class="underline" @click="onClickServiceCenter">자세히보기</span></div>
                    <div class="txt_info" style="margin-top:8px">고객에게 070번호가 아닌 기존 사용중인 특정 번호로 발신되길 원하시면 <strong>'발신번호 변경'</strong>을 진행해주세요. <span class="underline" @click="onClickServiceCenter">자세히보기</span></div>
                </div>
            </div>
         </ur-area>
         -->
         <service-request-new-modal ref="newModal" :pageId="contextPageId"/>
         <service-request-detail-modal ref="detailModal" />
    </aicc-page>
</template>
<script>
import BasePage from '~cm/components/BasePage';
import PGE_AIS_00001_P01 from './components/PGE_AIS_00001_P01'
import CMP_AIC_00001 from '../../components/CMP_AIC_00001';

export default {
    name: 'PGE_AIS_00001', // eslint-disable-line vue/name-property-casing
    extends: BasePage,
    components:{
        serviceRequestDetailModal:PGE_AIS_00001_P01,
        aiccMultiDropdown:CMP_AIC_00001,
    },
    data() {
        return {
            searchInfo:{
                type:{
                    label:'요청구분',
                    items:[
                        {text:'전체', value:'',},
                        {text:'전화번호/채널 신규', value:'A',},
                        {text:'전화번호/채널 변경', value:'B',},
                    ],
                    value:'',
                },
                date:{
                    label:'요청일자',
                    init:'day-6',
                    value:[],
                },
                status:{
                    label:'상태',
                    items:[
                        {text:'접수중', value:'A'},
                        {text:'완료', value:'B'},
                        {text:'반려', value:'C'},
                    ],
                    value:[
                        {text:'접수중', value:'A'},
                        {text:'완료', value:'B'},
                        {text:'반려', value:'C'},
                    ],
                },
            },
            headers:[
                {text:'상태',},
                {text:'요청구분',},
                {text:'요청자',},
                {text:'요청일자',},
                {text:'적용일자',},
            ],
            date:[],
            dataList:[],
            items:[],
            totalText:'',
            perPageText:'',
            pagination:{
                rowsPerPage:10,
                currentPage:1,
                totalPages:1,
                totalItems:0,
            },
            noDataText:' ',
            selectedSrId:'',
        }
    },
    created(){},
    mounted(){
        this.totalText = '총';
        this.perPageText = '건씩 보기';
        this.initMultiDropdown();
        this.getSrList();
    },
    computed:{
        selectedSrIdProps(){
            return this.selectedSrId;
        },
        fromDTM(){
            return this.date[0]+'000000';
            //return this.searchInfo.date.value[0]+'000000';
        },
        toDTM(){
            return this.date[1]+'235959';
            //return this.searchInfo.date.value[1]+'235959';
        },
        /*
        noDataText(){
            if(this.searchInfo.type.value === '' && this.searchInfo.status.value.length === this.searchInfo.status.items.length) {
                return '서비스 요청 내역이 없습니다.';
            } else {
                return '선택하신 조건의 조회결과가 없습니다.';
            }
        },
        */
    },
    watch:{
        date: {
            immediate:true,
            handler(newVal, oldVal) {
                if(oldVal && oldVal != newVal) {
                    this.searchInfo.type.value = '';
                    this.initMultiDropdown();
                }
            }
        },
    },
    methods:{
        initMultiDropdown(){
            const tempArray = [
                {text:'접수중', value:'A'},
                {text:'완료', value:'B'},
                {text:'반려', value:'C'},
            ];
            this.searchInfo.status.items = [];
            this.searchInfo.status.value = [];
            for(let index in tempArray) {
                this.searchInfo.status.items.push(tempArray[index]);
                this.searchInfo.status.value.push(tempArray[index]);
            }
        },
        getSrList(){
            let srStatusList = [];
            for(let index in this.searchInfo.status.value) {
                srStatusList.push(this.searchInfo.status.value[index].value);
            }
            http.request(this.contextPageId, 'DTS_AIS_00001', {
                data : {
                    srType:this.searchInfo.type.value,
                    fromDTM:this.fromDTM,
                    toDTM:this.toDTM,
                    status:srStatusList,
                }
            })
            .then(res => {
                this.dataList = [];
                for(let index in res.data.serviceRequestList) {
                    this.dataList.push(res.data.serviceRequestList[index]);
                }
                if(this.dataList.length < 1) {
                    this.noDataText = '선택하신 조건의 조회결과가 없습니다.';
                }
                this.buildPages();
                this.dataToItems();
            })
            .catch(error => {
                console.warn(error);
            })
        },
        changeRowPerPage(rows){
            let pagination = this.pagination;
            this.pagination.currentPage = 1;
            this.pagination.rowsPerPage = rows;
            this.pagination.totalPages = Math.ceil(pagination.totalItems / pagination.rowsPerPage);
            this.dataToItems();
        },
        changeCurrentPage(page){
            this.pagination.currentPage = page;
            this.dataToItems();
        },
        buildPages(){
            let data = this.dataList;
            this.pagination.totalItems = data.length;
            this.pagination.totalPages = Math.ceil(data.length / this.pagination.rowsPerPage);
            this.pagination.currentPage = 1;
        },
        dataToItems(){
            let currentPage = this.pagination.currentPage;
            let rowsPerPage = this.pagination.rowsPerPage;
            let data = this.dataList;
            let st = (currentPage - 1) * rowsPerPage;
            let ed = Math.min(currentPage * rowsPerPage, data.length);
            let arr = [];
            for(let index = st ; index < ed ; index++) {
                arr.push(data[index]);
            }
            this.items = arr;
        },
        getStatusColor(status){
            switch(status) {
                case 'A':
                    return 'success';
                case 'B':
                    return 'default';
                case 'C':
                    return 'error';
                default:
                    return 'default';
            }
        },
        getStatusText(status){
            switch(status) {
                case 'A':
                    return '접수중';
                case 'B':
                    return '완료';
                case 'C':
                    return '반려';
                default:
                    return 'N/A';
            }
        },
        getTypeText(type){
            switch(type) {
                case 'A':
                    return '전화번호/채널 신규';
                case 'B':
                    return '전화번호/채널 변경';
                default:
                    return 'N/A';
            }
        },
        getFormattedDate(date){
            return utils.toStringByFormat(utils.toDate(date), 'YYYY-MM-DD');
        },

        onClickSearchButton(){
            this.getSrList();
        },
        onClickSRButton(){
            this.$refs['newModal'].open();
        },
        onClickRow(item) {
            this.$refs['detailModal'].open(item.srId);
        },
        onClickServiceCenter(){
            window.open(this.$t('MSG_TXT_AICC_CUSTOMER_CENTER_URL'));
            //window.alert('고객지원센터로 이동 예정');
        },
    },
}
</script>
<style scoped>
    .-page-root-container {
        height: 100%;
        overflow-y: auto;
    }
    /*
    .search-box {
        width:100%;
        height:64px;
        display:flex;
        align-items: center;
    }
    .search-box__label {
        width: 120px;
        font-size: 16px;
        text-align: right;
        margin-left: 32px;
    }
    .search-box__label__first {
        width: 120px;
        font-size: 16px;
        text-align: right;
        margin-left: 22px;
    }
    */
    .search-button {
        float: right;
    }
    .sr_btn {
        font-size: 14px;
        padding: 0 16px;
    }
    .ur-dropdown {
        width: auto;
    }
    .sr_icon {
        background-image: url('../../../../assets/images/aicc/ic_request.png');
        width: 16px;
        height: 16px;
        display: inline-block;
        position: relative;
        top: 1px;
        margin-right: 4px;
    }
    .more_info {
        margin-top:60px;
        display: flex;
        align-items: center;
        height: 112px;
    }
    .txt_info {
        display: flex;
        align-items: center;
        width:100%;
        height: 20px;
        font-weight: 500;
        background:unset;
        padding-left: 0;
    }
    .txt_info i {
        display: inline-block;
        background: url('../../../../assets/images/aicc/ic_notice.png');
        width: 16px;
        height: 16px;
        margin-right: 8px;
    }
    .txt_info strong {
        font-size:14px;
        font-weight: 500;
    }
    .link {
        text-decoration: underline;
        margin-left: 16px;
        font-size: 16px;
        color: #333;
    }
    .underline {
        text-decoration: underline;
        cursor: pointer;
    }
    .ur-area {
        min-width: 1248px;
    }
    .ur-table {
        overflow-x: unset;
    }
    ::v-deep .ur-table > .ur-table__control {
        min-width: 1248px;
    }
    ::v-deep .ur-table > .ur-table__area > .ur-table__body > tr {
        cursor: pointer;
    }
    /*
    .more_info i {
        background-image: url('../../../../assets/images/aicc/ic_info.png');
        width: 16px;
        height: 16px;
        display: inline-block;
    }
    .more_info_text {
        height: 20px;
        font-size: 14px;
    }
    .more_info_text span {
        font-weight: 500;
    }
    .more_info_text.more_info_text {
        margin-top:8px;
    }
    */
</style>